'use es6';

export const version = '1';